// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3h_2S","itemTitle":"ClientEmergencyInfo_itemTitle__bEmrJ","itemText":"ClientEmergencyInfo_itemText__1IkIo"};